export const INTERVAL_INFO = {
  oneMinute: "1m",
  oneHour: "1H",
  oneDay: "1d",
  five: 5,
  eight: 8,
  nine: 9,
  twentyOne: 21,
  twentyFour: 24,
  thirtyTwo: 32,
  sixty: 60,
  hundredEighty: 180,
  thousand: 1000
};

export const AXIS_COLOR_CODE = {
  xAxis: "#000000",
  yAxis: "#A64DB8",
  zAxis: "#456CE5",
  temperature: "#B25252"
};

export const UNITS_V_A_HZ = ["voltageUnit", "currentUnit", "freqUnit"];
export const UNITS_AP = ["activePowerUnit", "powerFactorUnit"];
export const UNITS_PO = ["activePowerUnit", "apparentPowerUnit"];
export const UNITS_THD_THC = ["thdVUnit", "thdCUnit"];

export const TITLES = {
  VOLTAGE: "Voltage",
  CURRENT: "Current",
  FREQUENCY: "Frequency"
};
export const TITLES_V_A_HZ = {
  VOLTAGE: "Voltage",
  CURRENT: "Current",
  FREQUENCY: "Frequency"
};
export const TITLES_AP = {
  ACTIVE_POWER: "Active Power",
  POWER_FACTOR: "Power Factor"
};
export const TITLES_PO = {
  ACTIVE_POWER: "Active Power",
  APPARENT_POWER: "Apparent Power",
  NON_ACTIVE_POWER: "Non Active Power"
};
export const TITLES_THD_THC = {
  THD_VOLTAGE: "THD Voltage",
  THD_CURRENT: "THD Current",
  HARMONIC_CONTENT_CURRENT: "Harmonic Content Current"
};

export const PRECISION = {
  VOLTAGE: 1,
  CURRENT: 2,
  FREQUENCY: 2,
  ACTIVE_POWER: 2,
  POWER_FACTOR: 2,
  APPARENT_POWER: 2,
  NON_ACTIVE_POWER: 2,
  THD_VOLTAGE: 1,
  THD_CURRENT: 1,
  HARMONIC_CONTENT_CURRENT: 2
};
export const OFFSETS = {
  VOLTAGE: -30,
  CURRENT: -20,
  FREQUENCY: -40,
  ACTIVE_POWER: -40,
  POWER_FACTOR: -40,
  APPARENT_POWER: -40,
  NON_ACTIVE_POWER: -40,
  THD_VOLTAGE: -20,
  THD_CURRENT: -20,
  HARMONIC_CONTENT_CURRENT: -60
};

export const GRAPH_TYPE = {
  V_A_HZ: "V_A_HZ",
  AP: "AP",
  PO: "PO",
  THD_THC: "THD_THC"
};


export const STUDY_TYPE = {
  EnergyStudy: 1,
  LoadStudy: 2
};

export const GRAPH_DATA_TYPES = {
  Voltage: "VOLTAGE",
  Current: "CURRENT",
  Frequency: "FREQUENCY",
  ActivePower: "ACTIVE_POWER",
  PowerFactor: "POWER_FACTOR",
  ApparentPower: "APPARENT_POWER",
  NonActivePower: "NON_ACTIVE_POWER",
  THDV: "THD_VOLTAGE",
  THDC: "THD_CURRENT",
  HarmonicContentCurrent: "HARMONIC_CONTENT_CURRENT"
};

export const GRAPH_DATA_TRENDS_COLOR = {
  PrimaryPhaseA: "rgba(51, 51, 51, 1)",
  SecondaryPhaseA: "rgba(51, 51, 51, 0.75)",
  TertiaryPhaseA: "rgba(51, 51, 51, 0.5)",
  PrimaryPhaseB: "rgba(232, 68, 70, 1)",
  SecondaryPhaseB: "rgba(232, 68, 70, 0.75)",
  TertiaryPhaseB: "rgba(232, 68, 70, 0.5)",
  PrimaryPhaseC: "rgba(54, 123, 228, 1)",
  SecondaryPhaseC: "rgba(54, 123, 228, 0.75)",
  TertiaryPhaseC: "rgba(54, 123, 228, 0.5)",
  PrimaryTot: "rgba(45, 129, 104, 1)",
  SecondaryTot: "rgba(45, 129, 104, 0.75)",
  TertiaryTot: "rgba(45, 129, 104, 0.5)"
};

export const GRAPH_DATA_PHASE = {
  A: "A",
  AB: "AB",
  B: "B",
  BC: "BC",
  C: "C",
  CA: "CA",
  Tot: "Tot",
  Freq: "Freq"
};
